import React from 'react';
import { ChefHat, Leaf, Heart } from 'lucide-react';
import { brandPillars, brandAssets } from '../utils/mockData';

const iconMap = {
  'chef-hat': ChefHat,
  'leaf': Leaf,
  'heart': Heart,
};

export const ApproachSection = () => {
  return (
    <section id="approach" className="py-24 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-20">
            <h2 className="text-4xl md:text-5xl font-bold text-[#59642C] mb-6">
              Our Approach
            </h2>
            <div className="w-24 h-1 bg-[#FE9E1C] mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Three simple principles that define everything we create
            </p>
          </div>

          {/* Three Pillars */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
            {brandPillars.map((pillar, index) => {
              const Icon = iconMap[pillar.icon];
              return (
                <div
                  key={index}
                  className="group relative bg-gradient-to-br from-[#EBEBD3]/40 to-white p-10 rounded-3xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-[#EBEBD3]"
                >
                  {/* Icon Container */}
                  <div className="mb-8">
                    <div className="w-20 h-20 bg-[#59642C] rounded-2xl flex items-center justify-center group-hover:scale-110 group-hover:rotate-3 transition-all duration-300 shadow-lg">
                      <Icon className="w-10 h-10 text-white" strokeWidth={2} />
                    </div>
                  </div>

                  {/* Content */}
                  <h3 className="text-2xl font-bold text-[#59642C] mb-4">
                    {pillar.title}
                  </h3>
                  <p className="text-gray-700 text-lg leading-relaxed">
                    {pillar.description}
                  </p>

                  {/* Decorative Element */}
                  <div className="absolute top-6 right-6 text-7xl font-bold text-[#FE9E1C]/5 select-none">
                    0{index + 1}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Bottom Tagline */}
          <div className="mt-20 text-center">
            <p className="text-3xl font-bold text-[#961B1F] italic">
              #IDeserveit.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
